enum LabelIds {
  GLASS_ID = 100,
  ENTRY_DOOR_ID = 102,
  PATIO_DOOR_ID = 104,
  SLIDING_GLASS_DOOR_ID = 105,
  BRICK_ID = 200,
  STONE_ID = 202,
  WOOD_ID = 205,
  VINYL_ID = 206,
  STUCCO_ID = 209,
  CONCRETE_ID = 211,
  TUDOR_ID = 220,
  WRAP_ID = 221,
  UNKNOWN_ID = 222,
  WHITE_ID = 301,
  SHUTTER_ID = 400,
  TRIM_ID = 401,
  FASCIA_ID = 402,
  SOFFIT_ID = 403,
  ROOF_ID = 404,
  SASH_ID = 405,
  DOOR_PACKAGE = 408,
  OPENINGS_TRIM_ID = 409,
  HORIZONTAL_SIDING_ID = 601,
  VERTICAL_SIDING_ID = 602,
  SHINGLED_SIDING_ID = 603,
  OTHER_SIDING_ID = 604,
}

const PAINTABLE_MATERIALS = [
  LabelIds.BRICK_ID,
  LabelIds.FASCIA_ID,
  LabelIds.HORIZONTAL_SIDING_ID,
  LabelIds.OPENINGS_TRIM_ID,
  LabelIds.OTHER_SIDING_ID,
  LabelIds.SHINGLED_SIDING_ID,
  LabelIds.SOFFIT_ID,
  LabelIds.STUCCO_ID,
  LabelIds.TRIM_ID,
  LabelIds.TUDOR_ID,
  LabelIds.VERTICAL_SIDING_ID,
  LabelIds.VINYL_ID,
  LabelIds.WOOD_ID,
];

export { LabelIds, PAINTABLE_MATERIALS };
